// Local library
import { AccountFacade } from '@amwager/account/data-access';
import {
  DateFormatPipe,
  DecimalInputDirective,
  UnsubscribeObservableService
} from '@amwager/util';
import { SessionService } from '@amwager/data-access';

// Angular libray
import {
  AlertController,
  IonCheckbox
} from '@ionic/angular/standalone';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

// Third party
import { takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'feature-ion-wagering-limits',
  templateUrl: './wagering-limits.component.html',
  styleUrls: ['./wagering-limits.component.scss'],
  standalone: true,
  imports: [
    IonCheckbox,
    DecimalInputDirective,
    DateFormatPipe,
    FormsModule,
    CommonModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WageringLimitsComponent extends UnsubscribeObservableService implements OnInit {

  setTimer: number = 0;
  isWagerLimit: boolean = false;
  wagerLimit: number = 0;
  wagerLimitCopy: number = 0;
  activeBetLimit: boolean = false;
  wagerDailyLossLimit: number = 0;
  wagerDailyLossLimitCopy: number = 0;
  pendingLossLimit: number = 0;
  pendingLossLimitEffective: string = '';
  isTriggeredDailyLoss: boolean = false;
  isProcessing: boolean = false;
  currentState: string = '';

  constructor(
    private readonly sessionService: SessionService,
    private readonly alertCtrl: AlertController,
    private readonly accountFacade: AccountFacade,
    private readonly cdRef: ChangeDetectorRef,
  ) {
    super();

  }

  ngOnInit() {

    this.currentState = this.sessionService.getState();

    // API v1
    this.accountFacade.getAccountPreferencesAPI();
    this.accountFacade.isGetAccountPreferencesSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((callback) => {

        if (callback?.isSuccess === undefined) {
          this.isProcessing = false;
          this.cdRef.markForCheck();
          return;
        }

        const response = callback?.response?.AccountPreferences;

        this.isWagerLimit = response?.IsWagerLimit;
        this.wagerLimit = response?.WagerLimit;
        this.wagerLimitCopy = response?.WagerLimit;
        this.activeBetLimit = !this.isWagerLimit;
        this.isProcessing = false;

        this.cdRef.markForCheck();
      });

    if (this.currentState === 'NY')
      this.accountFacade.getAccountDailyLossLimitAPI();

    this.accountFacade.isGetAccountDailyLossLimitSuccess$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((callback) => {
      // console.log('callback ', callback);
      if (callback?.isSuccess === undefined || callback?.isSuccess === false) {
        if (callback?.isSuccess === false)
          this.showAlertMessage(callback?.response.error.Error);

        this.wagerDailyLossLimit = this.wagerDailyLossLimitCopy;
        this.isProcessing = false;
        this.cdRef.markForCheck();
        return;
      }

      const response = callback?.response;
      this.wagerDailyLossLimit = response.DailyLossLimit || 0;
      this.wagerDailyLossLimitCopy = this.wagerDailyLossLimit;

      if (this.isTriggeredDailyLoss) {
        this.pendingLossLimit = response.PendingLossLimit || 0;
        this.pendingLossLimitEffective = response.PendingLossLimitEffective || '';
        setTimeout(() => {
          this.isTriggeredDailyLoss = false;
          this.cdRef.markForCheck();
        }, 5000);
      }

      this.isProcessing = false;

      this.cdRef.markForCheck();
    });

  }

  onAmount($event: any): void {
    const amount = $event.target.value;

    if (amount === '') {
      this.showAlertMessage('Please insert a number');
      // this.wagerLimit = this.wagerLimitCopy;
      return;
    }

    if (amount > 65000) {
      this.showAlertMessage('The entered amount exceeds the limit of $65000');
      this.wagerLimit = this.wagerLimitCopy;
      return;
    }

    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }

    this.setTimer = setTimeout(() => {
      this.onBetLimit(amount);
    }, 500);
  }

  onBetLimit(amount: any): void {
    this.isProcessing = true;
    this.setTimer = 0;

    this.accountFacade.upsertAccountPrefenceFieldAPI(
      'WagerLimit',
      amount
    );
  }

  toggleCheckbox(): void {
    this.isWagerLimit = !this.isWagerLimit;
    this.activeBetLimit = !this.isWagerLimit;
    this.isProcessing = true;

    this.accountFacade.upsertAccountPrefenceFieldAPI(
      'IsWagerLimit',
      this.isWagerLimit ? 'true' : 'false'
    );
  }

  onDailyLossLimit(amount: any): void {
    this.isProcessing = true;
    this.setTimer = 0;
    this.isTriggeredDailyLoss = true;

    this.accountFacade.updatetAccountDailyLossLimitAPI(
      amount
    );
  }

  onDailyLossLimitAmount($event: any): void {
    const amount = $event.target.value;

    if (amount === '') {
      this.showAlertMessage('Please insert a number');
      // this.wagerDailyLossLimit = this.wagerDailyLossLimitCopy;

      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }

      return;
    }

    if (amount < 50) {
      this.showAlertMessage('Amount must be $50 or higher');
      // this.wagerDailyLossLimit = this.wagerDailyLossLimitCopy;
      return;
    }

    // if (amount > 10000) {
    //   this.showAlertMessage('The entered amount exceeds the limit of $10000');
    //   this.wagerDailyLossLimit = this.wagerDailyLossLimitCopy;
    //   return;
    // }

    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }

    this.setTimer = setTimeout(() => {
      this.onDailyLossLimit(amount);
    }, 500);
  }

  async showAlertMessage(message: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: 'Info',
      message: message,
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

}
